import React, { Component } from 'react';
import { View, Text, StyleSheet, ScrollView, TouchableWithoutFeedback, Image } from 'react-native';
import {QLinearGradient} from 'qunar-react-native';
import { observer, inject } from 'mobx-react/native';
import Icon from '../../Icon';
import uitls from '../businessComps/utils';
import { observable, computed } from 'mobx';
import QImageSet from '../../../assets/QImageSet.js';
import { navigate } from '../../../Utils/navigate';
import PPLogUtil from '../../../Utils/PPLogUtil';
import RootStore from '../../../Store';
import { UiStateInterface } from '../../../Store/uiState';


interface Props {
    data: Object,
    serviceBtnList: Array<Object>,
    index: number,
    uiState: UiStateInterface,
    privateCofirmVisible?(cofirmVisible: boolean,callback:any): void;
    onOrderItemPress(params: any, businessType: string,sysCode: any,orderNo: any,orderCellIndex: any): void;
}

@inject((stores: RootStore)=>({
    uiState: stores.uiState,
    privateCofirmVisible: stores.orderlist.privateCofirmVisible,
    // 点击订单
    onOrderItemPress: stores.orderlist.onOrderItemPress,
}))
@observer
export default class ServiceBtns extends Component<Props> {

    private scrollRef:any;

    @observable
    private scrollViewWidth = 0;

    @observable
    private buttonListWidth = 0;

    @computed
    private get shouldShowMoreMask(){
        return (this.scrollViewWidth < this.buttonListWidth - 1 - 20);
    }

    public componentDidUpdate(){
        if (this.scrollRef?.scrollTo) {
            this.scrollRef?.scrollTo({x: 0, y: 0, animated: false})
        }
    }


    public render() {
        const { data, serviceBtnList=[] } = this.props;
        const res = serviceBtnList.find(item => {
            return data?.orderNo === item?.orderNo;
        })

        if (!res) {
            return null;
        }

        const dataToShow = this.checkValidButtonList(res);

        if (!dataToShow) return null;

        const {imButton:{
            actionList=[],
            robotUrl
        }} = dataToShow;

        return (<View style={styles.container}>
            {!!robotUrl && <View style={styles.serviceButtonContainer}>
                <TouchableWithoutFeedback onPress={() => { this._onPressServiceBtn(robotUrl) }}>
                    <View style={styles.serviceBtn} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.CARD_KEFU)}>
                        <Image source={{ uri: QImageSet.service_btn_icon }} style={styles.serviceIcon} />
                        <Text style={styles.serviceBtnText}>客服</Text>
                        <Icon code="&#xea3f;" size={10} style={{color: '#00BCD4'}}/>
                    </View>
                </TouchableWithoutFeedback>
            </View>}
            <ScrollView
                scrollEnabled={this.shouldShowMoreMask}
                ref={ref=>{this.scrollRef = ref}}
                onLayout={e => {
                    const { width } = e.nativeEvent.layout;
                    this.scrollViewWidth = width;
                }}
                style={{ paddingLeft: 10 }}
                wx-height="28"
                horizontal={true}
                bounces={false}
                showsHorizontalScrollIndicator={false}>
                <View
                    style={styles.buttonListContainer}
                    onLayout={e => {
                        const { width } = e.nativeEvent.layout;
                        this.buttonListWidth = width;
                    }}
                >
                    {actionList.map((item:any, index:Number)=>{
                        return (
                            <TouchableWithoutFeedback key={index} onPress={()=>{this._onPressItem(item, index)}} accessible={false}>
                            <Text style={[styles.quickQuestionBtn, { marginRight: 20 }]} {...global.orderAccessibilityLabel(`${global.orderAccessibilityLabelName.CARD_PROBLEM_BTN}${index}`)}>
                                {item.actionName}
                            </Text>
                            </TouchableWithoutFeedback>
                        )
                    })}
                </View>
            </ScrollView>
            {/* {!!robotUrl &&<View style={styles.serviceButtonContainer}>
                <View style={styles.serviceLine} />
                <TouchableWithoutFeedback onPress={()=>{this._onPressServiceBtn(robotUrl)}}>
                    <View style={styles.serviceBtn} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.CARD_KEFU)}>
                        <Image source={{uri: QImageSet.service_btn_icon}} style={styles.serviceIcon}/>
                        <Text style={styles.serviceBtnText}>客服</Text>
                    </View>
                </TouchableWithoutFeedback>
            </View>} */}
            {/* 左侧阴影 */}
            <Image
                source={{ uri: QImageSet.list_left_shadow }}
                style={styles.leftShadow}
            />
            {this.shouldShowMoreMask && <QLinearGradient
                            locations={[0, 0.7, 1]}
                            colors={['#FFFFFF00', '#FFFFFFFF', '#FFFFFFFF']}
                            start={{x: 0.0, y: 0.5}}
                            end={{x: 1.0, y: 0.5}}
                            style={{ position: 'absolute', right: 0, top: 0, width: MASK_WIDTH, height: '100%' }}
                            pointerEvents={'none'} />}

        </View>)
    }


    private checkValidButtonList = (buttonListData: any)=>{
        const {
            imButton: {
                robotUrl = '',
                actionList = [],
            } = {}
        } = buttonListData;
        if (actionList.length === 0) return null;

        actionList.length = Math.min(actionList.length, 3);

        return buttonListData;
    }


    private _onPressItem = (item, btnIndex)=>{
        const { data={}, serviceBtnList=[],privateCofirmVisible,orderCellIndex,onOrderItemPress} = this.props;
        if(data?.private){
            const {appAction,businessType,sysCode,orderNo} = data;
            // 弹窗 show埋点
            PPLogUtil.privateOrderModal('privateOrderModalShow','show','1','pp/Privacy_order/Service_Tips/show/1')
            //privateVisible 无痕预定modal
            privateCofirmVisible(true,()=>{// 点击弹窗-去关闭 的回调
                // 去关闭埋点
                PPLogUtil.privateOrderModal('privateOrderToClose','click','2','pp/Privacy_order/Service_Tips/click/2');
                onOrderItemPress(uitls.getDetailSchema(appAction), businessType,sysCode, orderNo,orderCellIndex);
            });
            return;
        }

        navigate({
            isSchema: true,
            schema: item?.actionURL,
        })

        this.props.uiState.isBackFromOrderDetail = true;

        // 某种情况下会在跳转的瞬间触发行程的onShow时机,延迟再重置一次标记
        setTimeout(()=>{
            this.props.uiState.isBackFromOrderDetail = true;
        }, 500)


        // 埋点
        const { data: {
            businessType,
        } = {}, index } = this.props;

        PPLogUtil.logForQuickService({
            businessType,
            cardPosition: String(index),
            position: String(btnIndex),
            title: item?.actionName,
            operType: 'click',
        });
    }

    private _onPressServiceBtn = (robotUrl: string)=>{
        const { data={}, serviceBtnList=[],privateCofirmVisible,orderCellIndex,onOrderItemPress} = this.props;
        if(data?.private){
            const {appAction,businessType,sysCode,orderNo} = data;
            // 弹窗 show埋点
            PPLogUtil.privateOrderModal('privateOrderModalShow','show','1','pp/Privacy_order/Service_Tips/show/1')
            //privateVisible 无痕预定modal
            privateCofirmVisible(true,()=>{// 点击弹窗-去关闭 的回调
                // 去关闭埋点
                PPLogUtil.privateOrderModal('privateOrderToClose','click','2','pp/Privacy_order/Service_Tips/click/2');
                onOrderItemPress(uitls.getDetailSchema(appAction), businessType,sysCode, orderNo,orderCellIndex);
            });
            return;
        }
        if (!robotUrl) {
            return;
        }
        navigate({
            isSchema: true,
            schema: robotUrl,
        })

        this.props.uiState.isBackFromOrderDetail = true;

        // 某种情况下会在跳转的瞬间触发行程的onShow时机,延迟再重置一次标记
        setTimeout(()=>{
            this.props.uiState.isBackFromOrderDetail = true;
        }, 500)



        // 埋点
        const { data: {
            businessType,
        } = {}, index } = this.props;

        PPLogUtil.logForQuickService({
            businessType,
            cardPosition: String(index),
            title: '客服',
            operType: 'click',
        });

    }
}

const MASK_LEFT_WIDTH = 8;
const MASK_WIDTH = 50;

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        width: '100%',
        marginBottom: 16 - 7 - 9,
        marginTop: -7,
        paddingHorizontal: 16,
    },
    buttonListContainer: {
        flexDirection: "row",
        alignItems: 'center',
    },

    quickQuestionBtn: {
        color: '#00CAD8',
        fontSize: 12,
        paddingVertical: 7,
    },

    // service button
    serviceButtonContainer: {
        width: 56,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginRight: 25
    },

    serviceLine: {
        height: 10,
        width: 0.5,
        backgroundColor: '#00CAD8',
    },

    serviceBtn: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 7,
    },

    serviceIcon: {
        width: 30,
        height: 30
    },

    serviceBtnText: {
        color: '#00BCD4',
        fontSize: 14,
        fontWeight: '700',
        marginLeft: 4,
        marginRight: 1
    },

    leftShadow: {
        position: 'absolute',
        left: 98,
        top: 0,
        width: MASK_LEFT_WIDTH,
        height: 42
    }
})
